import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FamilyGrid.css'
import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import config from '../../config'
import { Link, LinkIcon } from '../../components'
// import convert from '../../helpers/convert'

// const ALL_ASSET = 'wff_all_asset_sum'
// const MIL_ASSET = 'wff_mil_asset_sum'
const CIV_ASSET = 'wff_civ_asset_sum'
// const ALL_WEIGHT = 'wff_all_weight_total'
// const MIL_WEIGHT = 'wff_mil_weight_total'
const CIV_WEIGHT = 'wff_civ_weight_total'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool
  }
  constructor(props){
    super(props)
    this.state = {
    }
  }

  componentWillMount() {
  }

  componentWillReceiveProps(props) {
  }

  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }

  renderCompanies = () => {
    let label = null
    let asset = null
    let weight = null
    switch (this.state.screen) {
      default:
        asset = CIV_ASSET
        weight = CIV_WEIGHT
        label = 'gun'
        break
    }

    return config.familyFunds.slice(0, 10).map((c,idx) =>{
      return this.renderCompany(
        idx,
        c.fund_family_name,
        c.label, c[asset],
        c[weight],
        c.num_equity_funds,
        4,
        label
      )
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  renderCompany = (idx, title, name, asset, perc, num, rating, label) => {
    const safeName = encodeURIComponent(title)
    // let round = true
    // if (convert.float(perc)<1.0) {
    //   round = false
    // }
    return(
      <Col key={idx} styleName='companies-box-wrap' xs={12} sm={4}>
        <Link
          onMouseEnter={this.onMouseEnter('company-'+idx)}
          onMouseLeave={this.onMouseLeave('company-'+idx)}
          log={analytics.eventToFamily(title)}
          to={config.routes.families+'?q='+safeName}
          styleName='companies-link'
          title={name}
        >
          <div styleName={'companies-box-'+rating}>
            <div styleName='box-title-wrapper'>
              { this.renderLogo(title, label) }
            </div>
            <div styleName='box-subtitle'>
              {num} equity funds analyzed
            </div>
            <br/>
            <div styleName='box-subtitle'>
              <strong>{format.money(asset, true, 'US Dollar', false, 1)}</strong>
              &nbsp;
              invested in gun manufacturers and major gun retailers
            </div>
            { /* <div styleName='box-subtitle'>
              {format.perc(perc, round)} {label} exposure
            </div> */ }
            <div styleName='learn-more-wrap'>
              <div styleName={'learn-more-'+rating}>
                More<LinkIcon/>
              </div>
            </div>
          </div>
        </Link>
      </Col>
    )
  }

  renderAddtl = () => {
    if (!this.props.fullGrid) {
      return null
    }

    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    return (
      <div>
        <div styleName='addtl-fam-info'>
          <strong>We analyze funds from over one hundred asset managers. See
          the full list below:</strong>
        </div>
        <div styleName='addtl-fam-links'>
          { filteredFams.map( (el, ix) => {
            return (
              <Link
                to={config.routes.list+'?srt=badge_count&ff='+el.name}
                title={el.name}
                key={el.name}
                strong={true}
              >
                <div styleName='addtl-fam-link'>
                  { el.name }<LinkIcon />
                </div>
              </Link>
            )
          }) }
        </div>
      </div>
    )
  }


  render() {
    return (
      <div styleName='companies'>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='companies-inner'>
          <div styleName='companies-title'>
            Major asset managers have billions invested in gun stocks
          </div>
          <div styleName='companies-info'>Are your savings invested with one
          of these financial giants? Click through and find out how much they
          have invested in gun manufacturers and major gun retailers.</div>
          <Row styleName='companies-boxes'>
            { this.renderCompanies() }
          </Row>
          { this.renderAddtl() }
        </div>
      </div>
    )
  }
}
